import React from 'react';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  Container,
} from '@mui/material';
import {
  ExitToApp as LogoutIcon,
  Person as PersonIcon,
} from '@mui/icons-material';

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  showHeader?: boolean;
  onLogout?: () => void;
  onProfile?: () => void;
  username?: string;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title = 'JackBot Admin',
  showHeader = true,
  onLogout,
  onProfile,
  username,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {showHeader && (
        <AppBar
          position="sticky"
          elevation={0}
          sx={{
            top: 0,
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
        >
          <Toolbar>
            <Typography
              variant="h6"
              component="div"
              sx={{
                flexGrow: 1,
                fontWeight: 600,
                color: 'primary.main',
              }}
            >
              {title}
            </Typography>
            
            {username && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  Welcome, {username}
                </Typography>
                
                {onProfile && (
                  <IconButton
                    onClick={onProfile}
                    sx={{ color: 'primary.main' }}
                    aria-label="Profile"
                  >
                    <PersonIcon />
                  </IconButton>
                )}
                
                {onLogout && (
                  <IconButton
                    onClick={onLogout}
                    sx={{ color: 'primary.main' }}
                    aria-label="Logout"
                  >
                    <LogoutIcon />
                  </IconButton>
                )}
              </Box>
            )}
          </Toolbar>
        </AppBar>
      )}
      
      <Box component="main" sx={{ flexGrow: 1 }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout; 